"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SliceKeySchema = exports.SliceKey = void 0;
const z = require("zod");
var SliceKey;
(function (SliceKey) {
    SliceKey["SigmaModelType"] = "sigma_model_type";
    SliceKey["ElementSigmaModelType"] = "element_sigma_model_type";
    SliceKey["Parameters"] = "parameters";
    SliceKey["ElementParameters"] = "element_parameters";
    SliceKey["SignalSet"] = "signal_set";
    SliceKey["Modes"] = "modes";
    SliceKey["SignalAttributes"] = "signal_attributes";
    SliceKey["Pinout"] = "pinout";
    SliceKey["PinAssignments"] = "pin_assignments";
    SliceKey["FloatingBehaviour"] = "floating_behaviour";
    SliceKey["SignalTies"] = "signal_ties";
    SliceKey["AmrBoundaries"] = "amr_boundaries";
    SliceKey["OcBoundaries"] = "oc_boundaries";
    SliceKey["DriveModes"] = "drive_modes";
    SliceKey["Resources"] = "resources";
    SliceKey["Functions"] = "functions";
    SliceKey["FunctionSignalMapping"] = "function_signal_mapping";
    SliceKey["Structure"] = "structure";
    SliceKey["SignalMapping"] = "signal_mapping";
    SliceKey["NcPins"] = "nc_pins";
})(SliceKey || (exports.SliceKey = SliceKey = {}));
exports.SliceKeySchema = z.nativeEnum(SliceKey);
//# sourceMappingURL=slice-key.js.map